module.exports = __webpack_public_path__ + "static/media/ponyo-back.05a1f501.jpg";